import { eGameAPI, Game } from "./Game";
import { SoundManager } from "./Utils/SoundManager";



export class SaveState {
    private static readonly KEY_HIGHSCORE = "marble:highScore";
    private static readonly KEY_AUDIO = "marble:audio";

    /**
     * Nejvyssi dosazene skore
     */
    static get highScore(): number { return SaveState._highScore; }
    static set highScore(value: number) {
        SaveState._highScore = value;

        if (Game.sdk) {
            localStorage.setItem(SaveState.KEY_HIGHSCORE, value.toString());
        }
    }
    private static _highScore: number = 0;

    static get audioEnabled(): boolean { return SaveState._audioEnabled; }
    static set audioEnabled(value: boolean) {
        SaveState._audioEnabled = value;

        if (Game.sdk) {
            localStorage.setItem(SaveState.KEY_AUDIO, SaveState._audioEnabled.toString());
        }
    }
    private static _audioEnabled: boolean = true;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static loadFromLocalStorage(): void {
        let value: string;

        if ((value = localStorage.getItem(SaveState.KEY_HIGHSCORE)))
            this._highScore = parseInt(value);

        if ((value = localStorage.getItem(SaveState.KEY_AUDIO))) {
            this._audioEnabled = JSON.parse(value);
            SoundManager.mute = !this._audioEnabled;
        }
    }
}